import { render } from "./client-quick-guide.vue?vue&type=template&id=23cf8bd4&ts=true"
import script from "./client-quick-guide.ts?vue&type=script&lang=ts&external"
export * from "./client-quick-guide.ts?vue&type=script&lang=ts&external"

import "./client-quick-guide.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__